import axios from 'axios';

export default {

  getTransfer(id) {
    return axios.get(`api/transfers/${id}`)
  },

  createTransfer(newTransfer) {
    return axios.post('api/transfers', newTransfer)
  },

  updateTransfer(id, updatedTransfer) {
    return axios.put(`api/transfers/${id}/status`, updatedTransfer)
  }

}